import { toast } from "react-toastify";
import axios from "axios";

export const onRunTask = async (apiUrl, taskId) => {
  try {
    await axios.get(`${apiUrl}/tasks/${taskId}/run`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    toast.success(`The ${taskId} task will begin shortly.`);
  } catch (e) {
    // Sanitize error logging to prevent log forging
    console.error("Error running task:", {
      taskId,
      message: e.message
        ? String(e.message).replace(/[\r\n]+/g, " ")
        : "Unknown error",
      status: e.response?.status ? Number(e.response.status) || null : null,
    });
    toast.error(
      e?.error?.body?.hasOwnProperty("hydra:description")
        ? `Error: ${String(e.error.body["hydra:description"]).replace(
            /[<>'"]/g,
            ""
          )}`
        : `There was a problem when attempting to run the ${String(
            taskId
          ).replace(/[<>'"]/g, "")} task.`
    );
  }
};
